import React from "react";
import "./Featured.css";
import bulgari_hotel_dubai from "../../../Gemco-Website-Images/Homepage/HP-13-bvlgari_hotel.jpg";
import Wynn_Al_Marjan_Island from "../../../Gemco-Website-Images/Homepage/HP-14-wynn_al_marjan.jpg";
import museum_of_the_future from "../../../Gemco-Website-Images/Homepage/HP-03-museum-of-the-future.webp";
import Clevel_and_Clinic_Abu_Dhabi from "../../../Gemco-Website-Images/Homepage/HP-15-Cleveland-clinic-abu-dhabi.jpg";
import Dubai_airport from "../../../Gemco-Website-Images/Homepage/HP-16-dubai_airport.jpg";
import Zaabeel from "../../../Gemco-Website-Images/Homepage/HP-17-Zaabel_Empower_DCP.webp";
const Featured = () => {
  return (
    <div className=" container wp_featured_wrap">
      <h1>OUR PROJECTS</h1>
      <h2>Trusted on UAE's Most Iconic Projects</h2>
      <div className="wp_featured_section">
        <div className="wp_featured_section_1">
            
          <div className="wp_featured">
            <div className="card">
              <img src={bulgari_hotel_dubai} alt="bulgari hotel dubai" />
              <a href="/our-projects/project/1"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="card-title text-ongoing">COMPLETED</h2>
                <div className="wp_card_title">Bvlgari Hotel Dubai</div>
              </div>
            </div>
          </div>

          <div className="wp_featured">
            <div className="card">
              <img src={Wynn_Al_Marjan_Island} alt="Wynn Al Marjan Island" />
              <a href="/our-projects/project/18"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="card-title text-ongoing">ONGOING</h2>
                <div className="wp_card_title">Wynn Al Marjan Island</div>
              </div>
            </div>
          </div>

          <div className="wp_featured">
            <div className="card">
              <img src={museum_of_the_future} alt="museum of the future" />
              <a href="/our-projects/project/2"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="card-title text-ongoing">ONGOING</h2>
                <div className="wp_card_title">Museum of the Future</div>
              </div>
            </div>
          </div>

          <div className="wp_featured">
            <div className="card">
              <img src={Clevel_and_Clinic_Abu_Dhabi} alt="Clevel and Clinic Abu Dhabi" />
              <a href="/our-projects/project/4"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="card-title text-ongoing">COMPLETED</h2>
                <div className="wp_card_title">Cleveland Clinic Abu Dhabi</div>
              </div>
            </div>
          </div>

          <div className="wp_featured">
            <div className="card">
              <img src={Dubai_airport} alt="Dubai Airport" />
              <a href="/our-projects/project/3"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="card-title text-ongoing">COMPLETED</h2>
                <div className="wp_card_title">Dubai Airport</div>
              </div>
            </div>
          </div>

          <div className="wp_featured">
            <div className="card">
              <img src={Zaabeel} alt="Za'abeel" />
              <a href="/our-projects/project/6"><h2 className="project-overlay">View Project</h2></a>
              <div className="card-body">
                <h2 className="wp_featured_card_text">COMPLETED</h2>
                <div className="wp_card_title">Za'abeel</div>
              </div>
            </div>
          </div>
        </div>
       <div className="wp_featured_view_all_btn">
            <a className="btn3" href="/our-projects">View All</a>
          </div>
      </div>
    </div>
  );
};

export default Featured;
